import * as ActionTypes from "./actionTypes";

export function loadExperiences(appKey) {
	return { type: ActionTypes.LOAD_EXPERIENCES, appKey };
}

export function loadExperiencesSuccess(experiences) {
	return { type: ActionTypes.LOAD_EXPERIENCES_SUCCESS, experiences };
}

export function loadExperiencesFail(errorMessage) {
	return { type: ActionTypes.LOAD_EXPERIENCES_FAIL, errorMessage };
}

export function loadExperience(expKey) {
	return { type: ActionTypes.LOAD_EXPERIENCE, expKey };
}

export function loadExperienceSuccess(experience) {
	return { type: ActionTypes.LOAD_EXPERIENCE_SUCCESS, experience };
}

export function loadExperienceFail(errorMessage) {
	return { type: ActionTypes.LOAD_EXPERIENCE_FAIL, errorMessage };
}

export function selectExperience(experienceId) {
	return { type: ActionTypes.SELECT_EXPERIENCE, experienceId };
}

export function createExperience(name, key, culture, appKey) {
	return { type: ActionTypes.CREATE_EXPERIENCE, name, key, culture, appKey };
}

export function createExperienceSuccess() {
	return { type: ActionTypes.CREATE_EXPERIENCE_SUCCESS };
}

export function createExperienceFail(errorMessage) {
	return { type: ActionTypes.CREATE_EXPERIENCE_FAIL, errorMessage };
}

export function editExperience(experienceId, experience) {
	return { type: ActionTypes.EDIT_EXPERIENCE, experienceId, experience };
}

export function editExperienceSuccess() {
	return { type: ActionTypes.EDIT_EXPERIENCE_SUCCESS };
}

export function editExperienceFail(errorMessage) {
	return { type: ActionTypes.EDIT_EXPERIENCE_FAIL, errorMessage };
}

export function deleteExperience(experienceId) {
	return { type: ActionTypes.DELETE_EXPERIENCE, experienceId };
}

export function deleteExperienceSuccess() {
	return { type: ActionTypes.DELETE_EXPERIENCE_SUCCESS };
}

export function deleteExperienceFail(errorMessage) {
	return { type: ActionTypes.DELETE_EXPERIENCE_FAIL, errorMessage };
}

export function loadExperienceNavigation(expId, callback) {
	return { type: ActionTypes.LOAD_EXPERIENCE_NAVIGATION, expId, callback };
}

export function loadExperienceNavigationSuccess(navigation) {
	return { type: ActionTypes.LOAD_EXPERIENCE_NAVIGATION_SUCCESS, navigation };
}

export function editExperienceNavigation(expId, navigation, submitHandler) {
	return { type: ActionTypes.EDIT_EXPERIENCE_NAVIGATION, expId, navigation, submitHandler };
}

export function editExperienceNavigationSuccess(navigation) {
	return { type: ActionTypes.EDIT_EXPERIENCE_NAVIGATION_SUCCESS, navigation };
}
